import React from "react";
import { Alert, Form, Select, Spin } from "antd";
import { useLanguage } from "src/providers/LanguageProvider";

type Option = { value: string | number; label: React.ReactNode };

type Props = {
  value?: string | number | null;
  options?: Option[];
  loading?: boolean;
  onChange?: (v: string | number | null) => void;
  error?: string | null;
};

const BuyLicensePlanSelect: React.FC<Props> = ({ value, options = [], loading, onChange, error }) => {
  const { t } = useLanguage();

  return (
    <>
      {error && (
        <Alert
          type="error"
          message={error}
          showIcon
          style={{ marginBottom: 8 }}
        />
      )}

      <Form layout="vertical" requiredMark={false}>
        <Form.Item label={t("LABEL_PRODUCT_PLAN")}>
          <Select
            value={value as any}
            showSearch
            allowClear
            placeholder={loading ? t("LOADING") : t("PLACEHOLDER_SELECT_PRODUCT_PLAN")}
            loading={!!loading}
            onChange={onChange as any}
            notFoundContent={loading ? <Spin size="small" /> : t("NO_RECORDS")}
            options={options}
            optionFilterProp="label"
            aria-label={t("LABEL_PRODUCT_PLAN")}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default BuyLicensePlanSelect;
